import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MediaObserver } from '@ngbracket/ngx-layout';
import { Observable, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';

import { Store } from '@ngrx/store';
import { TASK_MYSID, TasksFeature } from '@qtek/libs/store';
import { AppBarService, ToolbarConfig } from '@qtek/shared/services';

@Component({
  selector: 'qt-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ToolbarComponent implements OnInit, OnDestroy {
  private store = inject(Store);

  @Output() toggleToolbar: EventEmitter<void> = new EventEmitter<void>();
  @Output() toggleRightPanel: EventEmitter<void> = new EventEmitter<void>();
  @Output() openAiChat: EventEmitter<void> = new EventEmitter<void>();
  @Output() openTasks: EventEmitter<void> = new EventEmitter<void>();
  @Output() addNote: EventEmitter<void> = new EventEmitter<void>();
  @Output() addContact: EventEmitter<void> = new EventEmitter<void>();
  @Output() addDeal: EventEmitter<void> = new EventEmitter<void>();

  /** Whether navigation is in mini mode. */
  @Input() mini: boolean;
  @Input() isLargeScreen: boolean;
  @Input() rightPanelOpened: boolean;
  @Input() rightPanelActiveTab: 'chat' | 'tasks' | null;
  @Input() showAiChat = false;

  /** Hold active toolbar config. */
  toolbarConfig: ToolbarConfig;
  tasksCount$: Observable<number> = this.store
    .select(TasksFeature.selectTasksByMysid(TASK_MYSID.PERSONAL_TASKS))
    .pipe(
      map(
        (tasks: any[]) => tasks.filter(task => task.status === 'active').length
      )
    );

  destroy$ = new Subject<void>();

  constructor(
    public appBar: AppBarService,
    public media: MediaObserver,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.appBar.configChange
      .pipe(
        filter(value => !(value === null && this.toolbarConfig === null)),
        takeUntil(this.destroy$)
      )
      .subscribe(value => {
        this.toolbarConfig = value;

        this.changeDetectorRef.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
